<template>
    <div class="fixed w-full" style="z-index: 1030">
        <nav class="relative z-10 bg-primary-800 h-24">
            <div class="mx-auto max-w-dashboard">
                <div style="height: 100px" class="flex items-center h-24">
                    <div class="flex items-center h-full">
                        <div v-if="hasActiveDirectory" class="flex-shrink-0 h-full">
                            <LocationPicker></LocationPicker>
                        </div>
                    </div>
                    <div class="h-full w-full">
                        <div class="flex justify-end items-center divide-x divide-primary-700 h-full">
                            <div v-if="hasActiveDirectory" class="px-4 xl:px-6 h-full grid content-center">
                                <Notifications></Notifications>
                            </div>
                            <div v-if="hasRealTimeModuleEnabled && hasActiveDirectory" class="px-4 xl:px-6 h-full grid content-center">
                                <Notes></Notes>
                            </div>
                            <div v-if="hasAssignmentsMobuleEnabled && hasActiveDirectory && !hasRealtimeOnlyModule" class="px-4 xl:px-6 h-full grid content-center">
                                <Assignments></Assignments>
                            </div>
                            <div v-if="hasActiveDirectory && !hasRealtimeOnlyModule" class="px-4 xl:px-6 h-full grid content-center">
                                <ActionsMenu></ActionsMenu>
                            </div>
                            <div v-if="hasActiveDirectory && !hasRealtimeOnlyModule" class="px-4 xl:px-6 h-full grid content-center">
                                <CreateEventAction class="my-auto"></CreateEventAction>
                            </div>
                            <div v-if="canManageDirectory || cookieBotConfigured" class="px-4 xl:px-6 h-full grid content-center">
                                <GearMenu></GearMenu>
                            </div>
                            <div class="px-4 xl:px-6 h-full grid content-center">
                                <ProfileMenu></ProfileMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import CreateEventAction from '@/components/layouts/dashboardLayout/topBar/events/CreateEventAction.vue';
import Notifications from '@/components/layouts/dashboardLayout/topBar/notifications/Notifications.vue';
import Notes from '@/components/layouts/dashboardLayout/topBar/notes/Notes.vue';
import Assignments from '@/components/layouts/dashboardLayout/topBar/assignments/Assignments.vue';
import ProfileMenu from '@/components/layouts/dashboardLayout/topBar/profileMenu/ProfileMenu.vue';
import GearMenu from '@/components/layouts/dashboardLayout/topBar/gearMenu/GearMenu.vue';
import ActionsMenu from '@/components/layouts/dashboardLayout/topBar/actionsMenu/ActionsMenu.vue';
import LocationPicker from '@/components/layouts/dashboardLayout/topBar/locationPicker/LocationPicker.vue';
import { store } from '@/plugins/store';
import { Module } from '@/types';

export default defineComponent({
    components: { CreateEventAction, Notifications, Notes, Assignments, ProfileMenu, GearMenu, ActionsMenu, LocationPicker },
    setup() {
        const hasAssignmentsMobuleEnabled = computed(() => store.getters.hasModuleEnabled(Module.Assignments));
        const hasRealTimeModuleEnabled = computed(() => store.getters.hasModuleEnabled(Module.RealTime));
        const hasActiveDirectory = computed(() => store.getters.hasActiveDirectory);
        const hasRealtimeOnlyModule = computed(() => store.getters.hasRealtimeOnlyModule);
        const canManageDirectory = computed(() => store.getters.loggedInUserCanManageDirectory);
        const cookieBotConfigured = computed(() => process.env.VUE_APP_COOKIE_BOT_DOMAIN_ID !== undefined);

        return {
            hasRealTimeModuleEnabled,
            hasAssignmentsMobuleEnabled,
            hasActiveDirectory,
            hasRealtimeOnlyModule,
            canManageDirectory,
            cookieBotConfigured,
        };
    },
});
</script>
